import { Controller } from "@hotwired/stimulus"
import { purchaseAddon } from "../../utils/addon-purchase.util"
import { isAbortError } from "../../utils/fetch-error.util"

// One-click add-on purchase: the limit modal's "add an extra account and
// continue" (and the PSD2 account picker's buy button). Submits the form as
// JSON so a card that needs 3-D Secure is authenticated in place, then follows
// redirect_url — the form's return_to, validated by the server. The plain HTML
// POST stays the no-JS fallback. The flow itself lives in
// utils/addon-purchase.util.js, shared with billing--addon-quantity.
export default class extends Controller {
  static targets = ["button", "error"]
  static values = {
    publishableKey: String,
    syncUrl: String,
    texts: { type: Object, default: {} }
  }

  async submit(event) {
    event.preventDefault()
    this.toggle(true)
    this.showError("")
    let leaving = false

    try {
      const result = await purchaseAddon(this.element, {
        publishableKey: this.publishableKeyValue,
        syncUrl: this.syncUrlValue,
        texts: this.textsValue,
        tag: "addon-purchase"
      })
      if (!result.ok) {
        this.showError(result.error)
        return
      }
      if (!this.element.isConnected) return
      leaving = true
      this.navigate(result.redirectUrl)
    } catch (error) {
      if (isAbortError(error)) return
      console.error("[addon-purchase]", error)
      this.showError(this.textsValue.genericError)
    } finally {
      // Leaving: keep the button disabled while the next page loads, so a
      // second click cannot buy the same extra again.
      if (!leaving) this.toggle(false)
    }
  }

  // Separate so the spec can observe it: jsdom cannot assign location.href.
  navigate(url) {
    window.location.href = url
  }

  toggle(loading) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = loading
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.toggle("d-none", message === "")
  }
}
